import { render } from "./TreeNode.vue?vue&type=template&id=4755cd7c"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"
script.render = render

export default script